export enum TipoEstadoPrecio {
  Indeterminado = 0,
  Pendiente = 1,
  Aprobado = 2,
  Rechazado = 3,
  AprobadoRetroactivo = 4
}
